<img
  src="/assets/logo/large-logo.svg"
  alt="background-img"
  class="background-img"
/>
<div class="Chess-Puzzles-page-background-color">
  <div class="container-fluid">
    @if(computerGameData){
      <div class="row m-0 justify-content-start move-scroll horizontal-moves" #moveScrollContainerVertical>
        <div *ngFor="let item of computerGameData; let i = index" class="col-6 move-one-section p-0 mb-0 mt-1">
          <div class="d-flex align-items-center">
            <span *ngIf="i % 2 === 0" class="font mb-0 numbers">{{ i / 2 + 1 }}.</span>
            <p class="mb-1 move-box-border" 
              [ngClass]="{ 'selected-move':  i + 1 === currentIndex }"
             >
              {{ item }}
            </p>
          </div>
        </div>
      </div>
    }

    <div class="row">
     
      <div class="col-md-8 play-with-friend-Game ">
        <div class=" text-center mt-3">
          <div class="d-flex justify-content-center">
            <div class="Main-chessBoard">
              <div #boardContainer id="hijk"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 py-3 puzzle-menu-section">
        @if(!playerMode){ 
          @if(!challengeWaiting && !opponentWaiting){
            <div (click)="mainMenu()" style="color: var(--default-font-color); cursor: pointer;width: fit-content;">
          <i
            class="fa-solid me-1 fa-arrow-left"
            style="
              color: var(--default-font-color);
              cursor: pointer;
              font-size: 15px;
            "
          ></i>Back
        </div>
        }
       } @if(playerMode){
        <div>
          <div class="d-flex align-items-center justify-content-center">
            <h2 class="text-center Play-Chess-title-text">Play Chess</h2>
          </div>
          <div class="text-center play-main-box my-3">
            <img
              src="/assets/icon-image/Play-Chess-img.svg"
              style="width: 20%"
              alt=""
            />
          </div>
          <div class="d-grid puzzle-main-manu">
            <div
              (click)="multiplayerGame()"
              class="d-flex justify-content-center"
            >
              <div class="d-flex align-items-center puzzle-menu p-3">
                <div class="img-box-size">
                  <img
                    src="/assets/icon-image/Play-Online-mode.svg"
                    class="img-size"
                    alt=""
                  />
                </div>
                <div class="ms-3">
                  <h5 class="text-start Puzzles-box-text">MultiPlayer Game</h5>
                  <p class="m-0 text-start box-paragraph-text">
                    Play vs a person of similar skill
                  </p>
                </div>
              </div>
            </div>
            <div (click)="computerMode()" class="d-flex justify-content-center">
              <div class="d-flex align-items-center puzzle-menu p-3">
                <div class="img-box-size">
                  <img
                    src="/assets/icon-image/Computer.svg"
                    class="img-size"
                    alt=""
                  />
                </div>
                <div class="ms-3">
                  <h5 class="text-start Puzzles-box-text">Computer</h5>
                  <p class="m-0 text-start box-paragraph-text">
                    Challenge a bot from Easy to Master
                  </p>
                </div>
              </div>
            </div>
            <div
              (click)="gameTypeSelect()"
              class="d-flex justify-content-center"
            >
              <div class="d-flex align-items-center puzzle-menu p-3">
                <div class="img-box-size">
                  <img
                    src="/assets/icon-image/Play -a-Friend.svg"
                    class="img-size"
                    alt=""
                  />
                </div>
                <div class="ms-3">
                  <h5 class="text-start Puzzles-box-text">Friend Game</h5>
                  <p class="m-0 text-start box-paragraph-text">
                    Rush against another player to win
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        }@else if(computerModeSelect){
        <div class="Computer-box mt-2">
          <div class="">
            <h2 class="mode-select text-center">
              Player <span class="text-info">vs</span> Computer
            </h2>
            @if(selectMode){
            <div class="d-grid justify-content-center">
              <img
                [src]="
                  currentTheme.currentTheme === 'light' ||
                  currentTheme.currentTheme === 'classic'
                    ? selectMode.darkImage
                    : selectMode.image
                "
                alt="icon"
              />
              <p class="text-center mode-select">{{ selectMode.mode }}</p>
            </div>
            <hr style="color: gray" />
            } @if(!chessBoardShow){
            <div class="d-grid justify-content-center mt-4">
              @for(mode of computerModeData; track $index){
              <div class="d-flex align-items-center" (click)="modeSelect(mode)">
                <div class="mode-box me-3 my-2">
                  <img
                    class="mode-images"
                    [src]="
                      currentTheme.currentTheme == 'light' ||
                      currentTheme.currentTheme === 'classic'
                        ? mode.darkImage
                        : mode.image
                    "
                    alt="icon"
                  />
                </div>
                <h3 class="mode-select">
                  {{ mode.mode }}
                </h3>
              </div>
              }
            </div>
            }@else {
            <div
              class="row w-100 move-scroll desktop-move justify-content-start mt-2"
              style="padding: 0px 20px"
              #moveScroll
            >
              @for (move of computerGameData; track $index) {
              <div class="col-6 mb-1 p-0 d-flex align-items-center">
                <span
                  *ngIf="$index % 2 === 0"
                  class="ms-1 d-flex"
                  style="color: var(--default-font-color); width: 15%"
                  >{{ $index / 2 + 1 }}.</span
                >
                <p
                  class="game-finish-box"
                  [innerHTML]="move | pieceIcon"
                  [ngClass]="{ 'selected-move': $index + 1 === currentIndex }"
                >
                  {{ move }}
                </p>
              </div>
              }
            </div>
            }
          </div>
        </div>
        @if(!chessBoardShow){
        <button
          (click)="chooseMode(selectMode)"
          [disabled]="!selectMode"
          class="computer-select-btn mt-2"
        >
          Play
        </button>
        } } @if(challangeMode){

        <div class="my-3">
          <h2 class="mb-0 text-center Play-Chess-title-text">
            Friend Challenge
          </h2>
        </div>

        <div class="my-2 text-center">
          <button
            class="btn mb-0 invite-link-btn w-50"
            (click)="friendCallenge('null')"
          >
            Invite with Link
          </button>
        </div>

        <div class="search-container-data">
          <div class="form-group position-relative">
            <input
              type="text"
              class="form-control"
              [formControl]="searchControl"
              placeholder="Search"
            />
            @if(searchControl.value){
            <span
              class="position-absolute top-50 end-0 translate-middle-y me-3"
            >
              <i class="fas fa-times" (click)="clearSearch()"></i>
            </span>
            }
          </div>

          @if(results?.length){
          <div class="search-player" (scroll)="onScroll($event)">
            @for (item of results; track $index) {
            <div
              class="d-flex align-items-center justify-content-between p-2 box-player"
            >
              <div class="d-flex align-items-center">
                <img
                  class="player-img me-2"
                  [src]="item?.image || '/assets/customer-image/men-shadow.png'"
                  alt="profile picture"
                />

                <p class="search-font-color m-0">
                  {{ item.username }}
                </p>
              </div>

              <div>
                <button
                  class="btn challenge-btn"
                  (click)="friendCallenge(item?.username)"
                >
                  Challenge
                </button>
              </div>
            </div>
            } @if (isLoading) {
            <div class="text-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            }
          </div>
          }
        </div>
        <div class="my-2">
          <h4 class="mb-0 Play-Chess-title-text">Friends</h4>
        </div>
        @if (friendsList?.length > 0) {
        <div class="friend-invite-data mb-3">
          @for(list of friendsList; track $index){
          <div class="d-flex mb-2 align-items-center justify-content-between">
            <div
              class="d-flex align-items-center"
              (click)="profilememberDetails(list?.username)"
              style="cursor: pointer"
            >
              <div style="position: relative" class="me-2">
                <img
                  class="player_image"
                  [src]="list?.image || '/assets/customer-image/men-shadow.png'"
                  alt="profile picture"
                />
                <div [ngClass]="list.online ? 'green_dot' : 'red_dot'"></div>
              </div>
              <h5 class="box-paragraph-text">
                {{ list?.username }}
              </h5>
            </div>
            <div>
              <button
                class="btn challenge-btn"
                (click)="friendCallenge(list?.username)"
              >
                Challenge
              </button>
            </div>
          </div>

          }
        </div>
        }@else {
        <div class="text-center">
          <p class="box-paragraph-text">No Friends Available</p>
        </div>
        <div class="text-center mt-5">
          <button class="btn invite-link-btn w-50" (click)="makeFriend()">
            Make More Friends
          </button>
        </div>
        } } @if(gameMode){

        <div class="gameMode-section my-3">
          <div class="timer-Select">
            <button class="btn dropdown-section" type="button">
              <div class="d-flex justify-content-center align-items-center">
                <img [src]="formattedImage" class="me-1" alt="" />
                {{ formattedTime }}
              </div>
            </button>
          </div>

          <div class="mt-3">
            <div class="d-flex mb-2">
              <img
                src="/assets/icon-image/bullet-img.svg"
                class="me-2"
                alt=""
              />
              <p class="m-0">Bullet Mode</p>
            </div>
            <div class="d-flex">
              @for (mode of BulletMode; track $index) {
              <button
                class="btn m-1"
                [ngClass]="
                  formattedTime == mode?.time
                    ? 'active-Timer-Select'
                    : 'unactive-Timer-Select'
                "
                (click)="selectModeValue(mode)"
              >
                {{ mode.time }}
              </button>
              }
            </div>
          </div>

          <div class="mt-3">
            <div class="d-flex mb-2">
              <img src="/assets/icon-image/blitz-img.svg" class="me-2" alt="" />
              <p class="m-0">Blitz Mode</p>
            </div>
            <div class="d-flex">
              @for (mode of BlitzMode; track $index) {
              <button
                class="btn m-1"
                [ngClass]="
                  formattedTime == mode?.time
                    ? 'active-Timer-Select'
                    : 'unactive-Timer-Select'
                "
                (click)="selectModeValue(mode)"
              >
                {{ mode.time }}
              </button>
              }
            </div>
          </div>

          <div class="mt-3">
            <div class="d-flex mb-2">
              <img src="/assets/icon-image/rapid-img.svg" class="me-2" alt="" />
              <p class="m-0">Rapid Mode</p>
            </div>
            <div class="d-flex">
              @for (mode of RapidMode; track $index) {
              <button
                class="btn m-1"
                [ngClass]="
                  formattedTime == mode?.time
                    ? 'active-Timer-Select'
                    : 'unactive-Timer-Select'
                "
                (click)="selectModeValue(mode)"
              >
                {{ mode.time }}
              </button>
              }
            </div>
          </div>

          <div class="mt-3">
            <div class="d-flex mb-2">
              <img src="/assets/icon-image/playAS.svg" class="me-2" alt="" />
              <p class="m-0">i play as</p>
            </div>
            <div class="d-flex">
              <div class="form-group mb-2">
                <div class="form-check p-0 form-check-inline">
                  <label class="radio-button-label black-side-box">
                    <input
                      type="radio"
                      name="playedAS"
                      (change)="onPlayASChange($event)"
                      value="W"
                    />
                    <img
                      src="/assets/icon-image/white-side.svg"
                      style="width: 50px; height: 50px"
                      alt=""
                    />
                  </label>
                </div>
                <div class="form-check p-0 form-check-inline">
                  <label class="radio-button-label black-side-box">
                    <input
                      type="radio"
                      name="playedAS"
                      (change)="onPlayASChange($event)"
                      value="B"
                    />
                    <img
                      src="/assets/icon-image/black-side.svg"
                      style="width: 50px; height: 50px"
                      alt=""
                    />
                  </label>
                </div>
                <div class="form-check p-0 form-check-inline">
                  <label class="radio-button-label random-side-box">
                    <input
                      type="radio"
                      name="playedAS"
                      (change)="onPlayASChange($event)"
                      value="R"
                      checked
                    />
                    <img
                      src="/assets/icon-image/ramdom-player.png"
                      style="width: 50px; height: 50px"
                      alt=""
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex mb-2 mt-2">
            <img
              src="/assets/icon-image/advanced.png"
              class="me-2"
              style="width: 20px; height: 20px"
              alt=""
            />
            <p class="m-0">Rating</p>
          </div>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="toggleSwitch"
              (change)="toggleSwitch($event.target)"
              [checked]="switchState"
            />
            <label class="form-check-label rating-select" for="toggleSwitch">{{
              switchState ? "On" : "Off"
            }}</label>
          </div>

          <div class="d-flex justify-content-end align-items-center me-3">
            <p
              class="m-0"
              style="cursor: pointer; color: var(--default-font-color)"
              (click)="toggleAdvancedOptions()"
            >
              Custom
              <i
                class="ms-1 fas"
                [ngClass]="{
                  'fa-chevron-up': showAdvancedOptions,
                  'fa-chevron-down': !showAdvancedOptions
                }"
              ></i>
            </p>
          </div>

          @if(showAdvancedOptions){
          <div class="time-selector-section-component">
            <div class="advanced-options">
              <div class="row mt-2">
                <div class="form-group col-md-6">
                  <label for="minRating">Minimum Rating</label>
                  <input
                    type="number"
                    id="minRating"
                    (change)="validateRatings()"
                    [(ngModel)]="minRating"
                    class="form-control"
                    placeholder="e.g. 200"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="maxRating">Maximum Rating</label>
                  <input
                    type="number"
                    id="maxRating"
                    (change)="validateRatings()"
                    [(ngModel)]="maxRating"
                    class="form-control"
                    maxlength="3"
                    placeholder="e.g. 1275"
                  />
                </div>
              </div>
              <div class="row mt-2">
                <div class="form-group col-md-6">
                  <label for="minutes">Minutes</label>
                  <input
                    class="form-control"
                    id="minutes"
                    [(ngModel)]="minutes"
                    (input)="updateTime()"
                    type="number"
                    placeholder="min"
                    data-tooltip-target="25"
                    min="0"
                    max="60"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="increment">Increment</label>
                  <input
                    class="form-control"
                    id="increment"
                    [(ngModel)]="increment"
                    (input)="updateTime()"
                    type="number"
                    placeholder="inc"
                    data-tooltip-target="27"
                    value="0"
                  />
                </div>
              </div>

              <div class="row mt-2 align-items-center">
                <div class="form-group col-md-6">
                  <label for="visibility">Game Visibility</label>
                  <select
                    id="visibility"
                    [(ngModel)]="visibility"
                    class="form-select"
                  >
                    <option value="private">Private</option>
                    <option value="public">Public</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-check-label" for="move-sounds"
                    >Move Sounds</label
                  >
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="move-sounds"
                      [(ngModel)]="moveSounds"
                    />
                  </div>
                </div>
              </div>
              @if(errorMessage){
              <div class="alert alert-danger mt-2">
                {{ errorMessage }}
              </div>
              }
            </div>
          </div>
          }
          <div class="timer-Select my-4">
            @if (playerSide) {
            <button
              class="btn dropdown-section"
              [disabled]="!type"
              (click)="startgame()"
              type="button"
            >
              Challange
            </button>
            }@else {
            <button
              class="btn dropdown-section"
              (click)="multiplayersumbit()"
              type="button"
            >
              Play
            </button>
            }
          </div>
        </div>

        } @if(opponentWaiting){
        <div class="opponent-Waiting mt-2">
          <div class="p-3">
            <div class="">
              <div class="text-center">
                <h4 class="m-0 box-paragraph-text">
                  {{ loginuserData?.username }}
                </h4>
              </div>
              <div class="d-flex justify-content-center mt-2">
                <h6
                  class="m-0 box-paragraph-text text-center p-1 game-opponent-waiting-time"
                >
                  {{ formattedTime }}
                </h6>
              </div>
              <div class="d-flex justify-content-center mt-2">
                @if(multiplayerGameDetails){
                <div>
                  <h3 class="m-0">
                    {{
                      multiplayerGameDetails?.whiteSidePlayer ==
                      loginuserData?.username
                        ? multiplayerGameDetails?.blackSidePlayer
                        : multiplayerGameDetails?.whiteSidePlayer
                    }}
                  </h3>
                </div>

                }@else {
                <div class="m-0 box-paragraph-text d-flex align-items-center">
                  Waiting for Opponent
                  <p class="loader ms-1"></p>
                </div>
                }
              </div>
              <div class="text-center">
                <button
                  (click)="multiplayerclose()"
                  class="btn opponent-cancel-btn mt-2"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        } @if(challengeWaiting){
        <div class="opponent-Waiting mt-2">
          <div class="p-2">
            <div class="d-flex justify-content-center mt-2">
              <div class="m-0 box-paragraph-text d-flex align-items-center">
                Waiting for Opponent
                <p class="loader ms-1"></p>
              </div>
            </div>
            <div class="text-center">
              <button
                class="btn opponent-cancel-btn mt-2"
                (click)="sharepopup()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        } @if(gamelinkCreate){
        <div class="opponent-Waiting mt-2">
          <div class="p-3">
            <div class="modal-body">
              <div class="d-flex justify-content-center">
                <h4 class="box-paragraph-text text-center m-0">
                  Share With Friend
                </h4>
              </div>
              <div class="d-flex justify-content-center mt-3">
                <a
                  class="ms-3"
                  (click)="whatsappLink()"
                  target="_blank"
                  data-action="share/whatsapp/share"
                >
                  <i
                    class="fa-brands fa-whatsapp"
                    style="color: #269009; opacity: inherit; font-size: x-large"
                  ></i>
                </a>
                <a class="ms-3" (click)="facebookLink()" target="_blank">
                  <i
                    class="fa-brands fa-facebook"
                    style="color: #045bf1; opacity: inherit; font-size: x-large"
                  ></i>
                </a>
                <a class="ms-3" target="_blank">
                  <i
                    (click)="copyText()"
                    class="fa-solid fa-copy"
                    style="
                      color: #0561ff;
                      opacity: inherit;
                      font-size: x-large;
                      cursor: pointer;
                    "
                  ></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: challengeWaiting }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h4 class="modal-title text-center m-0">Waiting For Player</h4>
        <div class="d-flex align-items-center">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            (click)="sharepopup()"
            aria-label="Close"
          ></button>
        </div>
      </div>
      <div class="modal-body d-flex justify-content-center">
        <div>
          <div class="preloader">
            <div class="chess-icon"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: gameoverPopup }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-center fontColor">Computer won</h4>
        <button
          type="button"
          class="btn-close"
          (click)="closegameOver()"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p class="m-0">{{ selectedMessage }}</p>
      </div>
    </div>
  </div>
</div>

<div
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{ display: AIlostgamePopup }"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-center fontColor">
          {{ loginuserData?.username }} won
        </h4>
        <button
          type="button"
          class="btn-close"
          (click)="closeAIlostgame()"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <p class="m-0">{{ loginuserData?.username }} Won</p>
      </div>
    </div>
  </div>
</div>

<app-login-popup
  [displayStyle]="modalDisplayStyle"
  (myout)="GetChildData($event)"
></app-login-popup>
